<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3dG5Lu/tc-custom/9781641085922.jpg?1713221680985" alt="This image is the cover for the book Kraken My Heart (Deutsch), Kraken-Krimi der Anderen Dimension"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kraken My Heart (Deutsch), Kraken-Krimi der Anderen Dimension
      </h1>
      <p class="bookDescription body article font2">
        <p>Es passt einfach alles zusammen: als Ted die Liebe seines Lebens kennenlernt, ist er von oben bis unten mit dem Blut eines Mordopfers bedeckt.<br/><br/> Ted Sturm arbeitet für ein Bestattungsunternehmen. Er hat ein loses Mundwerk, ein großes Herz und die zweifelhafte Gabe, mit Toten kommunizieren zu können. Unglücklicherweise sind Tote keine guten Freunde, und sein einziger lebender Freund, mit dem er auch die Wohnung teilt, hat gerade eine streunende Katze aufgenommen, die Ted das Leben zur Hölle macht. Und diese Katze - eigentlich ein Kater - hat es in sich. So kommt es, dass Ted sich plötzlich in einer anderen Dimension wiederfindet. Auf einer Leiche.<br/><br/> Ted wird des Mordes angeklagt und sein einziger Verbündeter in dieser merkwürdigen Welt voller magischer Wesen und Unwesen ist König Grell, ein sarkastischer, geiler, katzenartiger Unsterblicher mit beeindruckenden Fähigkeiten. Und einer beeindruckenden Anatomie. Die beiden werden in eine kosmische Verschwörung verwickelt, umgeben von gefährlichen Feinden. Mit Teds spezieller Begabung und Grells Magie müssen sie versuchen, der Sache auf den Grund zu gehen, um Teds Leben zu retten. Es gibt da nur ein Problem: Ted muss Grells unzweideutigen Avancen widerstehen. Und er ist sich nicht sicher, ob er das überhaupt will.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K.L. Hiers, Anna Doe
      </h2>
      
      <p class="authorDescription body article"><P>K.L. &ldquo;Kat&rdquo; Hiers is an embalmer, restorative artist, and queer writer. Licensed in both funeral directing and funeral service, she worked in the death industry for nearly a decade. Her first love was always telling stories, and she has been writing for over twenty years, penning her very first book at just eight years old. Publishers generally do not accept manuscripts in Hello Kitty notebooks, however, but she never gave up.</P><P>Following the success of her first novel,&#160;<I>Cold Hard Cash</I>, she now enjoys writing professionally, focusing on spinning tales of sultry passion, exotic worlds, and emotional journeys. She loves attending horror movie conventions and indulging in cosplay of her favorite characters. She lives in Zebulon, NC, with her husband and their children, some of whom have paws and a few who only pretend to because they think it&rsquo;s cute.</P><P><BR />Website: http://www.klhiers.com</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6de16094